import * as _ from 'lodash';
import type { FunctionComponent } from 'react';

import Button from '../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button/button-constants';
import ButtonGroup from '../../../generic/Button/ButtonGroup';
import NavigationButton from '../../../generic/Button/NavigationButton';
import { icons, IconText } from '../../../generic/Icon';
import { DOCS_URL } from '../../../generic/Link/index';
import Text from '../../../generic/Text';

type JiraSettingsHeaderProps = {
  subheading?: string;
  isSaveButtonEnabled?: boolean;
  onSave?: () => Promise<void>;
};

const JIRA_DOCS_URL = `${DOCS_URL}/atlassian-jira`;

/**
 * Top/header section for the Jira integration settings.
 */
const JiraSettingsHeader: FunctionComponent<JiraSettingsHeaderProps> = ({
  subheading = 'Integrate Jira to export, track and resolve issues.',
  isSaveButtonEnabled,
  onSave,
}) => (
  <header className="jira-settings__header">
    <div>
      <Text.H1>
        Jira Settings
      </Text.H1>
      <Text.Paragraph>
        {subheading}
      </Text.Paragraph>
    </div>
    <ButtonGroup>
      <NavigationButton
        to={JIRA_DOCS_URL}
        type={BUTTON_TYPE.SECONDARY}
        size={BUTTON_SIZE.MEDIUM}
      >
        <IconText
          icon={icons.book}
          text="View Docs"
        />
      </NavigationButton>
      {!_.isNil(isSaveButtonEnabled) && onSave &&
        <Button
          type={BUTTON_TYPE.PRIMARY}
          size={BUTTON_SIZE.MEDIUM}
          onClick={onSave}
          isDisabled={!isSaveButtonEnabled}
        >
          Save
        </Button>}
    </ButtonGroup>
  </header>
);

export default JiraSettingsHeader;
